import { createContext, useContext, useState, type ReactNode } from 'react';

type NavigationDirection = 'forward' | 'backward' | 'fade';

interface NavigationContextType {
  direction: NavigationDirection;
  setDirection: (direction: NavigationDirection) => void;
  navigateForward: () => void;
  navigateBackward: () => void;
  navigateFade: () => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export function NavigationProvider({ children }: { children: ReactNode }) {
  const [direction, setDirection] = useState<NavigationDirection>('fade');

  const navigateForward = () => setDirection('forward');
  const navigateBackward = () => setDirection('backward');
  const navigateFade = () => setDirection('fade');

  return (
    <NavigationContext.Provider
      value={{
        direction,
        setDirection,
        navigateForward,
        navigateBackward,
        navigateFade,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
}

export { useNavigationHook };

function useNavigationHook() {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within NavigationProvider');
  }
  return context;
}

// Re-export with original name for backward compatibility
export { useNavigationHook as useNavigation };
